import * as Yup from 'yup';
import { DocumentsFormFieldNames } from 'features/new-actor/enums/documentsFormFieldNames';
import { cniValidation } from 'features/new-actor/form/validation-rules/cniValidation';
import { BorrowerNaturalFormValues } from './borrowerInsuredForm';
import { DocumentsFormValues } from 'features/new-actor/types/optim/naturalPersonWithDocumentsFormValues';
import { borrowerNaturalPersonValidationRules } from './natural/borrowerNatural.validation';

// =============================================================================
// FIELD NAMES
// =============================================================================

export const BROKER_CONFIRMATION_FIELD = 'brokerConfirmation';

// =============================================================================
// FORM VALUES TYPES
// =============================================================================

export interface BorrowerInsuredWithDocumentsFormValues
  extends BorrowerNaturalFormValues {
  [DocumentsFormFieldNames.Documents]: DocumentsFormValues;
  [BROKER_CONFIRMATION_FIELD]?: boolean;
}

// =============================================================================
// VALIDATION RULES
// =============================================================================

export const borrowerInsuredWithDocumentsValidationRules = {
  ...borrowerNaturalPersonValidationRules,
  [DocumentsFormFieldNames.Documents]: Yup.object().shape({
    [DocumentsFormFieldNames.Cni]: cniValidation
  })
};

export const borrowerInsuredWithDocumentsValidationSchema = Yup.object().shape(
  borrowerInsuredWithDocumentsValidationRules
);

export interface BorrowerInsuredValidationOptions {
  requiresBrokerConfirmation?: boolean;
}

export const buildBorrowerInsuredWithDocumentsValidationSchema = ({
  requiresBrokerConfirmation = false
}: BorrowerInsuredValidationOptions = {}) => {
  if (!requiresBrokerConfirmation) {
    return borrowerInsuredWithDocumentsValidationSchema;
  }

  return borrowerInsuredWithDocumentsValidationSchema.shape({
    [BROKER_CONFIRMATION_FIELD]: Yup.boolean()
      .oneOf([true], 'Vous devez confirmer avoir vérifié les informations saisies')
      .required()
  });
};
